import type { ReactElement } from 'react'

import { PeriodMode } from '../../../../enums/periodMode'
import { useExpertBalanceSheetColumns } from '../../hooks/useExpertBalanceSheetColumns'
import type { ExpertBalanceSheetColumnDef } from '../../hooks/useExpertBalanceSheetColumns'
import { ExpertBalanceSheetTab } from '../../types/expertBalanceSheetView'
import type {
  ExpertBalanceSheetAssetRow,
  ExpertBalanceSheetLiabilityRow,
  ExpertBalanceSheetPeriodColumn,
} from '../../types/expertBalanceSheetView'
import { ExpertBalanceSheetTableContent } from './elements/ExpertBalanceSheetTableContent'

interface ExpertBalanceSheetTableCommonProps {
  isEmpty: boolean
  isError: boolean
  isLoading: boolean
  periods: ExpertBalanceSheetPeriodColumn[]
  periodType: PeriodMode | undefined
}

type ExpertBalanceSheetTableProps = ExpertBalanceSheetTableCommonProps &
  (
    | { tab: ExpertBalanceSheetTab.Assets; rows: ExpertBalanceSheetAssetRow[] }
    | { tab: ExpertBalanceSheetTab.LiabilitiesAndEquity; rows: ExpertBalanceSheetLiabilityRow[] }
  )

export const ExpertBalanceSheetTable = (props: ExpertBalanceSheetTableProps): ReactElement => {
  const { isEmpty, isError, isLoading, periods, periodType, tab } = props
  const columns = useExpertBalanceSheetColumns(tab, periods, periodType)

  if (tab === ExpertBalanceSheetTab.Assets) {
    return (
      <ExpertBalanceSheetTableContent
        columns={columns as ExpertBalanceSheetColumnDef<ExpertBalanceSheetAssetRow>[]}
        isEmpty={isEmpty}
        isError={isError}
        isLoading={isLoading}
        rows={props.rows}
      />
    )
  }

  return (
    <ExpertBalanceSheetTableContent
      columns={columns as ExpertBalanceSheetColumnDef<ExpertBalanceSheetLiabilityRow>[]}
      isEmpty={isEmpty}
      isError={isError}
      isLoading={isLoading}
      rows={props.rows}
    />
  )
}
